module.exports = __webpack_public_path__ + "img/team-name-2.1d5622f0.png";